import { View, StyleSheet } from '@react-pdf/renderer';

export default function DividerPDF() {
  const styles = StyleSheet.create({
    divider: {
      borderStyle: 'solid',
      borderWidth: 0.2,
      marginVertical: 2,
    },
  });
  return <View style={styles.divider} />;
}
